module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Jakob-jongen-foliedruk-afgeronde-hoeken-aquarel-drukwerk-thumbnail.6da556da.png";